import { render } from "./grid.html?vue&type=template&id=10ac84ad&ts=true"
import script from "./grid.vue?vue&type=script&lang=ts"
export * from "./grid.vue?vue&type=script&lang=ts"

import "./grid.scss?vue&type=style&index=0&lang=scss"

import exportComponent from "C:\\xampp\\htdocs\\mt7rk\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__